/**
 * SF-5100: the badge next to ServeFirst's own working company, so staff never pick the wrong
 * one of the many companies with "ServeFirst" in the name. Nothing for any other company.
 */
import { Tag } from 'antd';
import { ACCOUNT_TYPE_LABELS, INTERNAL_ACCOUNT_TYPE } from '../constants';

export const ServeFirstLiveTag: React.FC<{ accountType?: string | null }> = ({ accountType }) =>
  accountType === INTERNAL_ACCOUNT_TYPE ? (
    <Tag color="purple">{ACCOUNT_TYPE_LABELS[INTERNAL_ACCOUNT_TYPE]}</Tag>
  ) : null;
